import styled from 'styled-components'
import { setPaddingSize } from '../../../utils/contentfulStyles.utils'
import ImgUtil from '../../../utils/img.utils'

export const MediaTextContainer = styled.div<{
  $background: string
  $backgroundUrl: string
  $alignment: string
  $enableClickToEnlarge: boolean
  $topPadding: string
  $bottomPadding: string
  $mediaStyle: string
  $hasMediaAsset: boolean
  $pageType: string
  $useCase: string
}>`
  ${({
    theme,
    $background,
    $backgroundUrl,
    $alignment,
    $enableClickToEnlarge,
    $topPadding,
    $bottomPadding,
    $mediaStyle,
    $hasMediaAsset,
    $pageType,
    $useCase,
  }) => {
    let shadowOptions = ``
    if ($useCase == 'Events') $topPadding += { padding: 0 }
    if ($useCase == 'Events') $bottomPadding += { padding: 0 }
    if ($mediaStyle !== 'No Drop Shadow')
      shadowOptions += `
        .MediaText__Mask-Wrapper img, .MediaText__Mask-Wrapper video {
          box-shadow: 0px 40px 24px -24px ${theme.webMktNewPalette.alphaBlack[20]};
          ${theme.breakpoints.down('xs')} {
            box-shadow: 0px 20px 12px -12px ${theme.webMktNewPalette.alphaBlack[20]};
          }
        }
      `

    let paddingOptions = `
      padding-top: ${setPaddingSize($topPadding)}px;
      padding-bottom: ${setPaddingSize($bottomPadding)}px;
    `

    let themeStyles = ``
    if ($background === 'Dark') {
      themeStyles += `
        background: ${theme.webMktNewPalette.deepBlue[70]};
        .MediaText__Mask-Wrapper {
          &:before {
            background-image: radial-gradient(white 1px, transparent 0);
          }
        }

        .MediaText__Text-Container {
          .MediaText__Heading,
          .MediaText__subHeading,
          .MediaText__Body li,
          .MediaText__Body p {
            color: ${theme.webMktNewPalette.white};
          }
        }
      `
    } else if ($background === 'Orange') {
      themeStyles += `
        background: ${theme.webMktPalette.background.orange};
        .MediaText__Inner-Container {
          .MediaText__Text-Container {
            .CTA {
              color: ${theme.webMktPalette.text.primaryWhite};
            }
          }
        }
      `
    } else {
      themeStyles += `
        background: ${
          $background === 'Light'
            ? theme.webMktNewPalette.white
            : theme.webMktNewPalette.deepBlue[10]
        };

        .MediaText__Mask-Wrapper {
          &:before {
            background-image: radial-gradient(black 1px, transparent 0);
          }
        }

        .MediaText__Text-Container {
          .MediaText__Heading,
          .MediaText__Body li,
          .MediaText__Body p {
            color: ${theme.webMktNewPalette.black};
          }
        }
      `
    }

    if ($hasMediaAsset && $backgroundUrl) {
      themeStyles = `
        background: url(${ImgUtil.getResizedImageUrl($backgroundUrl, '')});
      `
    }

    let alignmentStyles = ``
    let gridLgBottom = $mediaStyle === 'No Drop Shadow' ? '24px' : '50px'
    let gridMdBottom = $mediaStyle === 'No Drop Shadow' ? '16px' : '40px'
    let gridSmBottom = $mediaStyle === 'No Drop Shadow' ? '3px' : '30px'

    const mediaAssetCenter =
      $pageType === 'events'
        ? `
      margin: auto;
    `
        : `
      margin-left: auto;
      padding-left: 64px;
    `

    alignmentStyles += `
      .MediaText__Image-Container {
        padding-bottom: ${gridLgBottom};

        ${theme.breakpoints.down('md')} {
          padding-bottom: ${gridMdBottom};
        }

        ${theme.breakpoints.down('md')} {
          padding-bottom: ${gridSmBottom};
        }
      }
    `

    if ($alignment === 'left') {
      alignmentStyles += `
        .MediaText__Outer-Container {
          justify-content: flex-end;
          display: flex;
        }

        .MediaText__Inner-Container {
          flex-direction: row;
        }

        .MediaText__Image-Container {
          text-align: right;

          .MediaText__Mask-Wrapper {
            ${mediaAssetCenter};
            
            &:before {
              left: 0px;
              bottom: -${gridLgBottom};
            }
          }

          margin-right: ${$pageType === 'events' ? 0 : 126}px;
          ${theme.breakpoints.down('md')} {
            margin-right: ${$pageType === 'events' ? 0 : 106}px;
             .MediaText__Mask-Wrapper {
              padding-left: ${$pageType === 'events' ? 0 : 48}px;
              &:before {
                bottom: -${gridMdBottom};
                left: 0px;
              }
            }
          }

          ${theme.breakpoints.down('sm')} {
            margin-right: 0;
             .MediaText__Mask-Wrapper {
              padding-left: 0px;
              &:before {
                bottom: -${gridSmBottom};
                left: -40px;
              }
            }
          }
        }
      `
    } else {
      alignmentStyles += `
        .MediaText__Inner-Container {
          flex-direction: row-reverse;
        }

        .MediaText__Image-Container {
          margin-left: 126px;

          .MediaText__Mask-Wrapper {
            padding-right: 64px;
            &:before {
              bottom: -${gridLgBottom};
              right: 0px;
            }
          }

          ${theme.breakpoints.down('md')} {
            margin-left: 106px;
            .MediaText__Mask-Wrapper {
              padding-right: 48px;
              &:before {
                bottom: -${gridMdBottom};
                right: 0px;
              }
            }
          }

          ${theme.breakpoints.down('sm')} {
            margin-left: 0;
            .MediaText__Mask-Wrapper {
              padding-right: 0px;
              &:before {
                bottom: -${gridSmBottom};
                right: -40px;
              }
            }
          }
        }
      `
    }

    let enableClick = ``
    if ($enableClickToEnlarge) {
      enableClick += `
        .MediaText__Mask--None,
        .MediaText__Mask--Image,
        .MediaText__Mask--Video {
          position: relative;
          video, img {
            display: block;
          }

          svg {
            position: absolute;
            bottom: 0;
            right: 0;
            z-index: 2;
            background: ${theme.webMktNewPalette.white};
            width: 48px;
            height: 48px;
            box-sizing: border-box;
            padding: 16px;

            .search-icon {
              fill: ${theme.webMktNewPalette.black};
            }
          }

          &:hover {
            &:before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background: ${theme.webMktNewPalette.alphaBlack[20]};
              z-index: 2;
            }

            svg {
              background: ${theme.webMktNewPalette.black};
              .search-icon {
                fill: ${theme.webMktNewPalette.white};
              }
            }
          }
        }
      `
    }

    const customSMBreakpoint = '1130px'
    const custommMDLGBreakpoint = '1400px'

    return `
      ${themeStyles}
      ${enableClick}
      ${alignmentStyles}
      ${paddingOptions}
      ${shadowOptions}
      
      .orangeTheme{
        background-color: ${theme.webMktNewPalette.orange[50]};
       .MediaText__Heading{color:${theme.webMktNewPalette.white}}
       .MediaText__subHeading{color:${theme.webMktNewPalette.white}}
       .MediaText__Body{
          p, li{color:${theme.webMktNewPalette.white}; vertical-align:text-top}
       }
      }
      .MediaText--Events {
          max-width: 100%;
          justify-content: center;
          padding: 0;
          margin: 0;
          display:flex;

          .MediaText__Inner-Container {
            width: 100%;
            flex:auto;
            justify-content:normal;

            .MediaText__Image-Container {
              width: 50%;
              max-width: initial;
              margin:0;
              padding:0;
              height:100%;
               ${theme.breakpoints.down('sm')} {
               width:100%;
               }

              .MediaText__Mask-Wrapper {
                width: 100%;
                height:100%;
                &:before {
                  display:none
                }
                .MediaText__Mask--Video {
                  > div:first-child {
                    width: 100%;
                    height: 100%;
                    > div:first-child {
                    width: 100%;
                    height: 100%;
                    .VideoPlayer__Image-File{
                      width:100%;
                      height:100%;
                      object-fit:cover;
                    }
                  }
                  }
                }
 
                .MediaText__Mask--Image{
                ${theme.breakpoints.down('sm')} {
                max-width:inherit
  }
                img {
                  object-fit: cover;
                  height:100%;
                }
               }
              }
            }
            .MediaText__Text-Container{
             
              margin:0 auto;
              max-width:598px;
              padding:136px 0;
               ${theme.breakpoints.down('lg')} {
                max-width:492px;
                padding:148px 0;
               }
                 ${theme.breakpoints.down('md')} {
                 padding:96px 0;
                 }
                 ${theme.breakpoints.down('sm')} {
                max-width:576px;
                
               }
               ${theme.breakpoints.down('xs')} {
                max-width:calc(100% - 32px);
                padding:48px 0;
               }
             
               .MediaText__subHeading{
               margin-top:16px;
              
                
              
                ${theme.breakpoints.down('xs')} {
                  
                    margin-top:8px;
                  }
               } 
              .MediaText__Body{ 
              ul{
              padding-bottom:0;             
                li{
                  margin-top:0;
                  p{
                  ${theme.breakpoints.down('lg')} {
                  
                  }
                  }
                }
                }
              }
            }
          }
        
      }

      .MediaText__Outer-Container--fullWidth{
        max-width:1680px;
        padding: 0px 40px;
        .MediaText__Inner-Container  {
          width: 100%;
          flex-wrap: wrap;
          justify-content: end;
          gap: 24px;
          margin-left: auto;
        }
        .MediaText__Image-Container{
          margin-right:0;
          max-width: calc(50% - 12px);
          padding-bottom:0;
          margin-left: 0;
          .MediaText__Mask-Wrapper{
            width:auto;
            max-width: 770px;
            &::before {
              bottom: -50px;
            }
          }
            .MediaText__Mask--Image{
            max-width:initial}
        }

        .MediaText__Text-Container {
         max-width: calc(50% - 12px);
         padding-top: 32px;
        }

        @media (max-width: 1130px) {
          .MediaText__Image-Container {
            max-width: 100%;
            .MediaText__Mask-Wrapper {
              max-width: 100%;
            }
          }

          .MediaText__Text-Container {
            max-width: 100%;
          }
        }
      }
      .MediaText__Inner-Container {
        width: 1367px;
        align-items: center;
        display: flex;
        flex: none;
        justify-content: space-between;

        ${theme.breakpoints.down('md')} {
          width: 1090px;
        }

        @media screen and (max-width: ${customSMBreakpoint}) {
          width: 100%;
          align-items: center;
          flex-direction: column;
          margin: 0 auto;
        }

        ${theme.breakpoints.down('xs')} {
          .MediaText__Text-Container {
            padding: 32px 0 0 0;
            &:before {
              content: none;
            }
          }

          .MediaText__Image-Container {
            padding: 0;
          }
        }
      }

      .MediaAsset {
        .MediaText__Image-Container {
          .MediaText__Mask-Wrapper {
            &:before {
              content: none;
            }
          }
        }
      }

      .MediaText__Image-Container {
        width: 100%;
        box-sizing: border-box;
        border-radius: 0px;
        position: relative;
        max-width: 754px;

        .MediaText__Mask--None,
        .MediaText__Mask--Image,
        .MediaText__Mask--Video  {
          position: relative;
        }

        .MediaText__Mask-Wrapper {
          width: 690px;
          display: flex;
          justify-content: center;
          position: relative;
          &:before {
            content: '';
            position: absolute;
            width: 360px;
            height: 240px;
            z-index: 0;
            background-size: 24px 24px;

            ${theme.breakpoints.down('xs')} {
              display: none;
            }
          }

          @media screen and (max-width: ${custommMDLGBreakpoint}) {
            width: 586px;
          }

          ${theme.breakpoints.down('md')} {
            width: 550px;
          }

          @media screen and (max-width: ${customSMBreakpoint}) {
            width: auto;
          }
        }

        img {
          position: relative;
          z-index: 1;
        }

        .MediaText__Mask--None {
          display: inline-block;
          min-width: 50%;
          img {
            width: auto;
            height: auto;
            min-width: 100%;
          }
        }

        .MediaText__Mask--Video {
          width: 100%;
          height: auto;
        }

        video {
          max-width: 100%;
        }

        .MediaText__Mask--Image {
          width: 100%;
          img {
            height: auto;
            width: 100%;
          }

          @media screen and (max-width: ${customSMBreakpoint}) {
            width: auto;
            height: auto;
          }
        }

        .MediaText__Mask--Video,
        .MediaText__Mask--Image {
          @media screen and (max-width: ${customSMBreakpoint}) {
            max-width: 682px;
            margin: 0 auto;
            width: 100%;
          }
        }

        ${theme.breakpoints.down('md')} {
          max-width: 598px;
        }

        @media screen and (max-width: ${customSMBreakpoint}) {
          max-width: 682px;
          text-align: center;
        }

        ${theme.breakpoints.down('xs')} {
          margin: 0;
          padding: 0;
        }
      }

      .MediaText__Text-Container {
        padding-top: 64px;
        width: 100%;
        box-sizing: border-box;
        position: relative;
        max-width: 486px;

        &:before {
          content: '';
          width: 80px;
          height: 4px;
          background: ${theme.webMktNewPalette.orange[50]};
          position: absolute;
          top: 0;
          left: 0;

          ${theme.breakpoints.down('xs')} {
            top: 32px;
          }
        }

        @media screen and (max-width: ${customSMBreakpoint}) {
          max-width: 548px;
          align-self: flex-start;
          &:before {
            content: none;
          }
        }

        ${theme.breakpoints.down('xs')} {
          padding-top: 60px;
          max-width: 100%;
        }

        .MediaText__Heading {
          margin: 0;
        }

        .MediaText__subHeading {
          margin-top: 24px;
        }

        .MediaText__Body {
          margin-top: 24px;
          ul {
            list-style: disc;
            padding-left: 24px;
          }

          li, p {
            margin: 0;
          }

          li {
            padding-left: 8px;
            margin-top: 8px;
            > p {
              margin: 0;
            }
          }

          ul, ol, > p {
            margin-top: 24px;
          }
        }

        .CTA {
          margin-top: 32px;
        }
      }
      
      .MediaAsset {
        justify-content: center;
        width: 100%;
      }
    `
  }}
`
